'use client';

import { useSyncExternalStore } from 'react';
const emptySubscribe = () => () => {};

/**
 * Returns `false` during a hydration render and `true` otherwise: while hydrating (and on the
 * server) React reads `getServerSnapshot`, and on any other render — including the first render
 * of a mount that happens after a client-side navigation — it reads `getSnapshot`. Use it to gate
 * query-derived values that would otherwise render SSR-visible structure the server could not
 * produce; unlike `useIsMounted`, a client-navigation mount never flashes the gated branch. The
 * post-hydration flip lands in a passive effect, the same phase as `useIsMounted`'s `useEffect`,
 * so this is not a paint-timing improvement. Keep `useIsMounted` in `Web3Provider`, where the
 * post-paint flip is load-bearing for EIP-6963 wallet discovery.
 */
export function useIsHydrated() {
  return useSyncExternalStore(emptySubscribe, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}